import './1618onlocation/style';
import FormStructure from './1618onlocation/form_structure';

export default FormStructure;